/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Muscles_EmptyInputs */

const en_us2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sets this week yet.`)
};

const pt_br2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série nesta semana ainda.`)
};

const es_419_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay series esta semana.`)
};

const pt_pt2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhuma série esta semana.`)
};

const fr_fr2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune série cette semaine pour l'instant.`)
};

const de_de2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Woche noch keine Sätze.`)
};

const it_it2_progress_muscles_empty = /** @type {(inputs: Progress_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna serie questa settimana.`)
};

/**
* | output |
* | --- |
* | "No sets this week yet." |
*
* @param {Progress_Muscles_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_muscles_empty = /** @type {((inputs?: Progress_Muscles_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Muscles_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_muscles_empty(inputs)
	if (locale === "es-419") return es_419_progress_muscles_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_muscles_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_muscles_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_muscles_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_muscles_empty(inputs)
	return en_us2_progress_muscles_empty(inputs)
});
export { progress_muscles_empty as "progress.muscles_empty" }